import { extractUniDataTableRows } from './extractUniDataTableRows'

export function isUniDataTableFieldShape(value: unknown): boolean {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false
  const typed = value as { type?: unknown; rows?: unknown; value?: unknown }
  if (String(typed.type ?? '').trim() === 'UniDataTable') return true
  if (Array.isArray(typed.rows)) return true
  if (typed.value && typeof typed.value === 'object' && Array.isArray((typed.value as { rows?: unknown }).rows)) {
    return true
  }
  return false
}

/** Имена полей-таблиц в ответе reload (для epoch inlineAfterLoad). */
export function collectUniDataTableFieldNamesFromReloadFields(
  reloadFields: Record<string, unknown> | null | undefined,
): string[] {
  if (!reloadFields || typeof reloadFields !== 'object' || Array.isArray(reloadFields)) {
    return []
  }
  const names: string[] = []
  for (const [key, value] of Object.entries(reloadFields)) {
    if (isUniDataTableFieldShape(value)) names.push(key)
  }
  return names
}

/** Число строк каждой UniDataTable в ответе reload. */
export function collectUniDataTableRowCountsFromReloadFields(
  reloadFields: Record<string, unknown> | null | undefined,
): Map<string, number> {
  const counts = new Map<string, number>()
  if (!reloadFields || typeof reloadFields !== 'object' || Array.isArray(reloadFields)) {
    return counts
  }
  for (const [key, value] of Object.entries(reloadFields)) {
    if (!isUniDataTableFieldShape(value)) continue
    counts.set(key, extractUniDataTableRows(value).length)
  }
  return counts
}

/** Не отправлять пустые UniDataTable в reload/panel — middle вернёт актуальные строки с сервера. */
export function omitEmptyUniDataTableFieldsFromReloadPayload(
  fields: Record<string, unknown>,
): Record<string, unknown> {
  const out: Record<string, unknown> = { ...fields }
  for (const [key, value] of Object.entries(fields)) {
    if (!isUniDataTableFieldShape(value)) continue
    if (extractUniDataTableRows(value).length === 0) {
      delete out[key]
    }
  }
  return out
}
